export enum ShiftApplicationState {
  ABORTED = 'ABORTED',
  ACCEPTED = 'ACCEPTED',
  ASSIGNED = 'ASSIGNED',
  CANCELED = 'CANCELED',
  CANCELED_BY_POOL_OPERATOR = 'CANCELED_BY_POOL_OPERATOR',
  DECLINED = 'DECLINED',
  DECLINED_BY_HUBLER = 'DECLINED_BY_HUBLER',
  NO_LONGER_ELIGIBLE = 'NO_LONGER_ELIGIBLE',
  PENDING = 'PENDING',
  WITHDRAWN = 'WITHDRAWN',
}
